import React from 'react';
import './about.css';
import AboutPresentation from './aboutpresentation/AboutPresentation';
import WhoWe from './whowe/WhoWe';
import EmployeesText from './employeestext/EmployeesText';
import { Helmet } from "react-helmet-async";

const About = () => {
    return (
        <>
            <Helmet>
                <title>Om oss | Cycle Solutions</title>
                <meta
                    name="description"
                    content="Om oss på Cycle Solutions: vi erbjuder balpressar från Bramidan och komprimatorer från Presto, med lång erfarenhet av avfallskomprimering i Sverige."
                />
                <link
                    rel="canonical"
                    href="https://cyclesolutions.se/about"
                />
            </Helmet>

            <div className='about'>
                <AboutPresentation />
                <EmployeesText />
                <WhoWe />
            </div>
        </>
    );
};

export default About;
